/* eslint-disable comma-dangle */
export default {
  en: {
    title: {
      speakers: 'Speakers',
      description: 'Get to know all the event speakers.',
    },
    biography: {
      title: 'Biography',
    },
    activities: {
      ongoing: 'Ongoing',
    },
  },
  es: {
    title: {
      speakers: 'Ponentes',
      description: 'Conoce a todos los ponentes del evento.',
    },
    biography: {
      title: 'Biografía',
    },
    activities: {
      ongoing: 'En curso',
    },
  },
  fr: {
    title: {
      speakers: 'Intervenants',
      description: 'Découvrez les intervenants de l\'événement.',
    },
    biography: {
      title: 'Biographie',
    },
    activities: {
      ongoing: 'En cours',
    },
  },
  ca: {
    title: {
      speakers: 'Ponents',
      description: 'Coneix tots els ponents de l’esdeveniment.',
    },
    biography: {
      title: 'Biografia',
    },
    activities: {
      ongoing: 'En curs',
    },
  },
  pt: {
    title: {
      speakers: 'Palestrantes',
      description: 'Conheça todos os palestrantes do evento.',
    },
    biography: {
      title: 'Biografia',
    },
    activities: {
      ongoing: 'Em andamento',
    },
  },
  it: {
    biography: {
      title: 'Biografia'
    },
    title: {
      speakers: 'altoparlanti',
      description: "Conosci tutti i relatori dell'evento."
    },
    activities: {
      ongoing: 'In corso',
    },
  },
  ja: {
    biography: {
      title: '経歴'
    },
    title: {
      description: 'すべてのイベントスピーカーを知る。',
      speakers: 'スピーカー'
    },
    activities: {
      ongoing: '進行中',
    },
  },
  zh: {
    title: {
      speakers: '演讲者',
      description: '了解所有活动发言人。'
    },
    biography: {
      title: '传记'
    },
    activities: {
      ongoing: '进行中',
    },
  },
  ar: {
    title: {
      speakers: 'مكبرات الصوت',
      description: 'تعرف على جميع المتحدثين بالحدث.',
    },
    biography: {
      title: 'سيرة',
    },
    activities: {
      ongoing: 'جاري',
    },
  },
  tr: {
    title: {
      speakers: 'Hoparlörler',
      description: 'Tüm Etkinlik konuşmacılarını tanıyın.',
    },
    biography: {
      title: 'Biyografi',
    },
    activities: {
      ongoing: 'Devam ediyor',
    },
  },
  de: {
    title: {
      speakers: 'Lautsprecher',
      description: 'Lernen Sie alle Redner der Veranstaltung kennen.'
    },
    biography: {
      title: 'Biografie'
    },
    activities: {
      ongoing: 'Laufend',
    },
  },
};
